import { Controller } from "@hotwired/stimulus"
import { searchPlants } from "../lib/plant_search"

// Plant name autocomplete with duplicate detection (server-side search).
// Values: field, placeholder, name, plantId, parentId
// Targets: input, duplicates
export default class extends Controller {
  static values = { field: String, placeholder: String, name: String, plantId: Number, parentId: Number }
  static targets = ["input", "duplicates"]

  search() {
    const q = this.inputTarget.value

    if (q !== "") {
      searchPlants({
        q,
        limit: 10,
        excludeId: this.plantIdValue || undefined,
        parentId: this.parentIdValue || undefined,
      }).then((result) => {
        this.renderDuplicates(result.hits)
      })
    } else {
      this.renderDuplicates([])
    }
  }

  renderDuplicates(hits) {
    if (hits.length > 0) {
      const links = hits.map(hit =>
        `<a href="${this.escapeHtml(hit.link)}">${this.escapeHtml(hit.scientific_name)} (${this.escapeHtml(hit.name)})</a>`
      ).join(", ")
      this.duplicatesTarget.innerHTML = `<p>Possible duplicates: ${links}</p>`
    } else {
      this.duplicatesTarget.innerHTML = ""
    }
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
